import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './ResponsibleMaintenance.module.css'

interface ResponsibleMaintenanceCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function ResponsibleMaintenanceCard({ score = 0, maxScore = 0, status = 'ADEQUADO' }: ResponsibleMaintenanceCardProps) {


    const setMessage = () => {
        if (status === 'ADEQUADO') {
            return (
                <div className='margin-top-20'>
                    Ótimo gerenciamento! Manutenções <b>dentro do limite do plano.</b>
                </div>
            )
        } else {
            return(
                <div className='margin-top-20'>
                    <div>Sua pontuação caiu. Verifique se há <b>faturas em aberto ou uso acima do esperado.</b></div>
                </div>
            )
        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default' style={{ height: 250 }}>
                <StatsWidget.Header>Adequação ao Plano</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                <div style={{ fontSize: 40 }}>
                                    <span className={styles["current-score"]}>{score}</span>
                                    <span className={styles["total-score"]}>/ {maxScore}</span>
                                </div>
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}